import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/reset.css";
import "./index.css";
import settingsService from "services/settingsService";

const TINYMCE_DEFAULT_KEY =
  "kqqjkb297wxx2inetsiwojudb0n0vkkcoejr1wbq00urc5ff";

function getTinyMCEKeyFromSettings() {
  return settingsService
    .getSettingsPublic("", false)
    .then((res) => {
      const data = Array.isArray(res?.data) ? res?.data?.[0] : res?.data;
      return data?.tinymceKey || TINYMCE_DEFAULT_KEY;
    })
    .catch(() => TINYMCE_DEFAULT_KEY);
}

const TINYMCE_LAST_KEY_STORAGE = "TINYMCE_API_KEY_LAST_USED";

function injectTinyMCEScript(key) {
  console.log('tiny key key', key)
  return new Promise((resolve, reject) => {
    if (window.tinymce) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = `https://cdn.tiny.cloud/1/${key}/tinymce/5/tinymce.min.js`;
    script.referrerPolicy = "origin";
    script.onload = () => {
      sessionStorage.setItem(TINYMCE_LAST_KEY_STORAGE, key);
      resolve();
    };
    script.onerror = () => reject(new Error("TinyMCE script failed to load"));
    document.head.appendChild(script);
  });
}

function renderApp() {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  serviceWorker.register();
}

// Register Firebase Messaging Service Worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(function (registration) {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch(function (error) {
      console.error("Service Worker registration failed:", error);
    });
}

// Fetch TinyMCE key from public settings API, inject script, then render app
getTinyMCEKeyFromSettings()
  .then((key) => injectTinyMCEScript(key))
  .then(renderApp)
  .catch((err) => {
    console.warn("TinyMCE load failed, rendering app anyway:", err);
    renderApp();
  });
